/**
 * Smooth native scroll
 * @module SmoothScroll
 *
 * @param {function} onscroll
 * @return {function} onscroll
 */

/* eslint-disable */

const SmoothScroll = onscroll => {
    const isTouch = 'ontouchstart' in window || navigator.msMaxTouchPoints;
    const el = document.querySelector('.smooth');
    const content = document.querySelector('.smooth-content');
    const body = document.querySelector('body');

    const stick = (el) => {

        var stickyTo = el.getAttribute('data-sticky-to');
        var stickyPosition = el.getAttribute('data-sticky-position');

        if (stickyTo != null) {

            var stickytToEl = document.querySelector(stickyTo).getBoundingClientRect().top;

            if (stickyPosition == "top") {
                var offset = el.getBoundingClientRect().height + 50;
            } else {
                var offset = window.innerHeight;
            }

            if (stickytToEl > offset) {
                if (window.disableScroll == false) {
                    el.style.transform = `translate3d(0, ${rounded}px, 0)`;
                }
            } else {
                // el.classList.add('hide');
            }

            

        } else {

            if (window.disableScroll == false) {
                el.style.transform = `translate3d(0, ${rounded}px, 0)`;
            }
        } 

    }

    const anchor = () => {

        var alist = document.querySelectorAll('a');

        for (var i = 0; i < alist.length; i++) {
            var a = alist[i];
            var url = a.getAttribute('href');
            var split = url.split('#');

            if (split.length > 1) {
                var hash = split.pop();

                if (hash !== "" && hash.length > 1) {

                    var selector = '#' + hash;

                    var section = document.querySelector(selector);

                    if (section) {

                        a.addEventListener('click', function(e) {

                            var offset = Number(body.getAttribute('data-scroll')) || 0;
                            offset += section.getBoundingClientRect().top;
                            offset -= 90;

                            window.scrollTo({
                                'behavior': 'smooth',
                                'left': 0,
                                'top': offset
                            });


                        })
                    }
                }
            }
            
        }
    }

    anchor();

    if(isTouch){

        window.addEventListener('scroll', () => onscroll(window.scrollY || window.pageYOffset), { passive: true });

        var stickys = document.querySelectorAll('.sticky-sm');

        if (stickys.length > 0) {

            for (var i = 0; i < stickys.length; i++) {

                (function(i) {

                    window.addEventListener('scroll', function(e){
                        stick(stickys[i]);
                    });
                    
                })(i);
                
            }
        }

    }

    else {

        var raf = requestAnimationFrame || webkitRequestAnimationFrame;
        var req;
        var current = 0;
        var last = 0;
        var rounded = 0;
        var ease = .09;

        const scroll = () => current = window.scrollY || window.pageYOffset;
        
        const onresize = () => {

            document.body.style.height = `${content.clientHeight}px`
            scroll()
        }
  
        const run = () => {

            if (!document.body.classList.contains('no-scroll')) {

                last += (current - last) * ease;
                rounded = Math.round(last * 100) / 100;

                window.yOffset = rounded;

                if (window.disableScroll == false) {
                    content.style.transform = `translate3d(0, -${rounded}px, 0)`;
                }

                body.setAttribute('data-scroll', rounded);

                if (document.body.style.height !== content.clientHeight + 'px') {
                    document.body.style.height = `${content.clientHeight}px`;
                }


                var stickys = document.querySelectorAll('.sticky');

                if (stickys.length > 0) {

                    for (var i = 0; i < stickys.length; i++) {

                        stick(stickys[i]);

                    }
                }

            }
            onscroll(rounded);
            raf(run);
            

        }
    
        window.addEventListener('resize', onresize, { passive: true })
        window.addEventListener('scroll', scroll, { passive: true })

        onresize();

        req = raf(run);

        Object.assign(el.style, {
            position: 'fixed',
           /* top: 0,*/
           /* left: 0,*/
           /* height: '100%',*/
           /* width: '100%',*/
            overflow: 'hidden'        
        })
    }

};

export default SmoothScroll;
